<template>
  <footer class="mt-pie">
    <div class="mt-contenedor mt-pie__rejilla">
      <div>
        <MinotariaMarca claro />
        <p class="mt-pie__lema">Le ayudamos a encontrar notaría y a preparar su trámite desde casa, sin registros y sin desplazamientos innecesarios.</p>
      </div>
      <nav aria-label="Enlaces" class="mt-pie__enlaces">
        <NuxtLink :to="ruta('/AvisoLegal')">Aviso legal</NuxtLink>
        <NuxtLink :to="ruta('/ProteccionDatos')">Protección de datos</NuxtLink>
        <NuxtLink :to="ruta('/PoliticaCookies')">Política de cookies</NuxtLink>
        <NuxtLink :to="ruta('/Accesibilidad')">Accesibilidad</NuxtLink>
        <NuxtLink :to="ruta('/tramites')">Guías de trámites</NuxtLink>
        <NuxtLink :to="ruta('/notarias')">Notarías en toda España</NuxtLink>
        <NuxtLink :to="{ path: ruta('/'), hash: '#notarias' }">Adherir mi notaría</NuxtLink>
        <NuxtLink v-if="blogActivo" :to="ruta('/blog')">Blog</NuxtLink>
      </nav>
    </div>
    <div class="mt-contenedor mt-pie__legal">
      <span>© {{ anio }} minotaria · <a href="https://unidata.es" target="_blank" rel="noopener">Unidata</a></span>
      <span>Los honorarios notariales están regulados por arancel. Usar minotaria no tiene coste.</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
import MinotariaMarca from './MinotariaMarca.vue'
import { useMinotariaBlog } from '../../composables/useMinotariaBlog'
const { activo: blogActivo } = useMinotariaBlog()
const route = useRouter().currentRoute
const ruta = (p: string) => (route.value.params.lang ? `/${route.value.params.lang}` : '') + p
const anio = new Date().getFullYear()
</script>
